module.exports = __webpack_public_path__ + "static/img/level-2-1.a38f349c.png";